<template>
    <div class="container">

        <ul class="body">
            <!-- 只在不是志愿者的时候显示申请入口 -->
            <li class="body-title f-c" v-if="this.getUserInfo.isVolunteer === 0" >
                <div class="f-c" v-touch:tap="pageRouter({routerName:'fillApplyVolunteerInfo'})">
                    <van-image 
                        class="icon-image"
                        lazy-load
                        fit="contain"
                        :src="iconImage"
                    />
                    <span class="name">申请成为志愿者</span>
                </div>
            </li>

            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >

                <li 
                    v-touch:tap="goToDetail(item)"
                    v-for="(item, index) in volunteerList" :key="index"
                    class="reder-item f-s-b"
                >
                    <van-image 
                        class="left-image-box"
                        lazy-load
                        fit="cover"
                        :src="item.image"
                    />
                    <div class="right-info-box f-s-b">
                        <div class="name ellipsis">{{item.title}}</div>
                        <div class="year ellipsis2">{{item.date}}</div>
                        <div class="good-at ellipsis">报名人数: {{item.peopleSize}}人</div>
                        <div class="good-at ellipsis">报名条件: {{item.condition}}</div>
                        <div class="level f-c leve-green" v-if="item.rawData.entryStatus === 1" >
                            <span>已报名</span>
                        </div>
                        <div class="level f-c leve-green" v-else-if="item.state === 2" >
                            <span>报名中</span>
                        </div>
                        <div class="level f-c" v-else>
                            <span>{{ item.state === 3 ? '已结束':'未开始'}}</span>
                        </div>
                    </div>
                </li>

            </van-list>   


            <van-tabbar 
                safe-area-inset-bottom
                v-model="active"
                active-color="#4899ff"
            >
                <van-tabbar-item 
                    v-touch:tap="pageRouter(item)"
                    class="tabbar-item zx-tabbar-item"
                    v-for="(item, index) in tabbarList" :key="index"
                >
                    <van-image 
                        class="tabbar-item-image"
                        :class="item.className"
                        lazy-load
                        fit="contain"
                        :src="item.image"
                    />
                    <div class="name">{{item.name}}</div>
                </van-tabbar-item>
            </van-tabbar>

        </ul>
    </div>
</template>

<script>
    import util from '@util';
    import { 
        List,
        Tabbar,
        TabbarItem,
    } from 'vant';
    import {
        volunteerActivityListUrl,
    } from '@js/volunteerUrl.js';
    import http from '@js/http-zyz.js'
    export default {
        data() {
            return {
                active: 2,
                tabbarList: [
                    {
                        name: '首页',
                        className: 'home-image',
                        image: require('@image/home/455.png'),
                        routerName: 'Home',
                    },
                    {
                        name: '个人中心',
                        image: require('@image/home/22.png'),
                        routerName: 'personalCenter',
                    },
                ],
                iconImage: require('@image/home/3.png'),
                volunteerList: [
                    {
                        image: require('@image/home/wanglili.png'),
                        title: '中秋志愿者报名',
                        date: '11月30日星期日  09:00-11:00',
                        peopleSize: 5,
                        condition: '讲解',
                        state: 1,
                    },
                    {
                        image: require('@image/home/wanglili.png'),
                        title: '中秋志愿者报名',
                        date: '11月30日星期日  09:00-11:00',
                        peopleSize: 5,
                        condition: '讲解',
                        state: 0,
                    },
                ],

                loading: false,
                finished: false,
                requestPrameter: {
                    pageNumber: 0,
                    pageSize: 10,
                }
            }
        },
        created() {
            this.requestPrameter.openId = this.userOpenId
            this.volunteerList = [];
        },
        methods: {
            pageRouter(item){
                return ()=>{
                    if(item.routerName) this.$router.push({ name: item.routerName })
                }
            },
            goToDetail(item){
                return ()=>{
                    var {
                        rawData
                    } = item;
                    this.$store.commit('setParmas',rawData);
                    this.$router.push({ name: 'volunteerDetail' })
                }
            },
            onLoad() {
                // // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                // setTimeout(() => {
                //     // this.randomList();
                //     // // 加载状态结束
                //     // this.loading = false;
                //     // // 数据全部加载完成
                //     // if (this.volunteerList.length >= 60) {
                //     //     this.finished = true;
                //     // }
                // }, 1000);
                this.getvolunteerActivityList();
            },
            getvolunteerActivityList(){
                this.requestPrameter.pageNumber++
                http.post(volunteerActivityListUrl,this.requestPrameter , {loading: false})
                    .then(res=>{
                        var {
                            success = true,
                            data: {
                                data:{
                                    pagerInfo,
                                    activityList:array = [],
                                }
                            }
                        } = res;
                        if(success && array.length > 0){
                            this.loading = false;
                            array.map(item=>{
                                let image  = '';
                                if(item.activityImgUrl){
                                    let array = String(item.activityImgUrl).split(',');
                                    if(array.length>0){
                                        image = array[0]
                                    }
                                }
                                this.volunteerList.push({
                                    image: image || require('@image/home/wanglili.png'),
                                    title: item.activityName,
                                    date: `${util.formatTime(new Date(item.activityStaTime), "时分秒")} - ${util.formatTime(new Date(item.activityEndTime), "时分秒")}`,
                                    peopleSize: item.peopleNumber,
                                    condition: String(item.requirements).replace(/,/g, " "),
                                    state: item.activityStatus,
                                    rawData: item,
                                })
                            })
                            if(this.volunteerList.length >= pagerInfo.totalCount){
                                this.finished = true;
                            }
                        }
                    })
                    .catch(error=>{
                        console.error(error)
                        this.finished = true;
                    })
            },
            randomList(){
                var volunteerList = [
                        {
                            image: require('@image/home/wanglili.png'),
                            title: '中秋志愿者报名',
                            date: '11月30日星期日  09:00-11:00',
                            peopleSize: 5,
                            condition: '讲解',
                            state: 1,
                        },
                        {
                            image: require('@image/home/wanglili.png'),
                            title: '中秋志愿者报名',
                            date: '11月30日星期日  09:00-11:00',
                            peopleSize: 5,
                            condition: '讲解',
                            state: 0,
                        },
                    ]
                for (let index = 0; index < (parseInt(Math.random()*10) + 20); index++) {
                    var tempIndex = parseInt(Math.random()*2);
                    this.volunteerList.push(volunteerList[tempIndex]);
                }
            },
        },
        computed: {
            userOpenId(){
                return this.$store.state.userInfo.openId || '';
            },
            getUserInfo(){
                var info = this.$store.state.userInfo.info || { isVolunteer: 0 };
                return info;
            },
        },
        components: {
            [List.name]: List,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .tabbar-item{
        text-align: center;
        width: 100%;
        position: relative;
        .icon-size{
            overflow: hidden;
            &::before{
            font-size: 20px;
            }
        }
        .tabbar-item-image{
            margin-top: 3px;
            width: 20px;
            height: 20px;
        }
        .name{
            font-weight: 500;
            margin-top: 5px;
            font-size: 10px !important;
            position: absolute;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
        }
        .home-image{
            background-color: #ffffff;
            padding: 5px;
            border-radius: 100%;
            overflow: hidden;
            width: 35px;
            height: 35px;
            transform: translateY(-20px);
            z-index: 5;
        }
    }
    .container{
        height: ~"calc(100% - 50px)" !important;
        position: relative;
        .header{

        }
        .body{
            // position: absolute;
            // left: 0;
            // right: 0;
            // top: 197px;
            @paddingSize:7px;
            padding: @paddingSize;
            box-sizing: border-box;
            .body-title{
                height: 50px;
                justify-content: flex-start;
                font-size:14px;
                font-weight:400;
                color:rgba(52,52,52,1);
                .icon-image{
                    height: 26px;
                    width: 30px;
                }
            }
            .reder-item{
                position: relative;
                overflow: hidden;
                margin-bottom: @paddingSize;
                padding: 25px 10px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                @size:114px;
                .left-image-box{
                    height: @size;
                    width: 162px;
                    border-radius:4px;
                    overflow: hidden;
                }
                .right-info-box{
                    flex-direction: column;
                    align-items: flex-start;
                    width: ~"calc(100% - 162px)";
                    height: @size;
                    padding-left: 16px;
                    box-sizing: border-box;
                    .name{
                        width: 100%;
                        // height:23px;
                        // width: ~'calc(100% - 92px)';
                        font-size:16px;
                        font-weight:500;
                        color:rgba(53,58,62,1);
                    }
                    .year,.good-at{
                        width: 100%;
                        // height:17px;
                        font-size:12px;
                        font-weight:500;
                        color:rgba(152,156,165,1);
                    }
                    .level{
                        font-weight:500;
                        font-size: 14px;
                        position: absolute;
                        right: 0;
                        width: 60px;
                        height: 28px;
                        bottom: 10px;
                        // top:10px;
                        font-size:14px;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        border-top-left-radius: 100px;
                        border-bottom-left-radius: 100px;
                        background:linear-gradient(to right,#E0E0E0,#D9D9D9);
                        .iconfont{
                            margin-right: 5px;
                        }
                    }
                    .leve-up{
                        color: #D4AB35;
                    }
                    .leve-green{
                        // color: #2FB147;
                        background:linear-gradient(to right,#00C6A2,#ACEFAB);
                    }
                    .leve-below{
                        color: #4282FF;
                    }
                }
                &:last-child{
                    margin: 0;
                }
            }
        }
    }
</style>